export default __webpack_public_path__ + "static/media/filter.e168024d.svg";